// Bejelentkezés utáni visszairányítás — csak saját oldalon belüli útvonal fogadható el
// (nyílt átirányítás ellen: //evil.com, /\evil.com, javascript:, vezérlőkarakterek).

const MAX_PATH_LENGTH = 2000;

// Bejelentkezés után ezekre nincs értelme visszamenni (körbeirányítás lenne) — főoldal.
const AUTH_PATHS = ['/bejelentkezes', '/regisztracio', '/elfelejtett-jelszo'];

const isAuthPath = (path: string) => {
  const pathname = path.split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';
  return AUTH_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
};

/** Biztonságos belső útvonal (pl. '/design-editor?product=9'), különben null. */
export function safeNextPath(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  if (raw.length === 0 || raw.length > MAX_PATH_LENGTH) return null;
  if (!raw.startsWith('/')) return null;
  // '//host' és '/\host' a böngészőben protokoll-relatív külső cím lehet.
  if (raw.startsWith('//') || raw.startsWith('/\\')) return null;
  // Vezérlőkarakterek (sortörés, tab, NUL…) és DEL.
  for (let i = 0; i < raw.length; i += 1) {
    const code = raw.charCodeAt(i);
    if (code < 0x20 || code === 0x7f) return null;
  }
  // Tartalék: ha az URL-feldolgozó mégis más eredetre oldaná fel, elutasítjuk.
  try {
    const base = 'http://belso.invalid';
    const resolved = new URL(raw, base);
    if (resolved.origin !== base) return null;
  } catch {
    return null;
  }
  return isAuthPath(raw) ? '/' : raw;
}

interface FromLocation {
  pathname?: unknown;
  search?: unknown;
}

/** Bejelentkezés utáni cél: a ProtectedRoute `state.from`-ja (lekérdezéssel együtt),
 *  különben a `?next=` paraméter, különben a főoldal. */
export function resolvePostLoginPath(state: unknown, search: string): string {
  const from =
    state && typeof state === 'object' && 'from' in state
      ? (state as { from?: FromLocation }).from
      : undefined;
  if (from && typeof from.pathname === 'string') {
    const query = typeof from.search === 'string' ? from.search : '';
    const target = safeNextPath(from.pathname + query);
    if (target) return target;
  }
  const next = safeNextPath(new URLSearchParams(search).get('next'));
  return next ?? '/';
}
